// extracted by mini-css-extract-plugin
export default {"buysetcell":"BuySetCell_buysetcell__4bw99","sell":"BuySetCell_sell__ibD6Z","count":"BuySetCell_count__LlYAt"};